/* eslint-disable default-param-last */
import { ajax } from 'rxjs/ajax';
import { map, catchError, finalize } from 'rxjs/operators';
import { OpenErrorNotification } from '@ctsu/react-ctsu-ui';
import { httpStatusEnum } from 'appconstants';

const getJSON = (value) => {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch (e) {
      return console.error(e);
    }
  }
  return value;
};

export const getErrorMessage = (e, k) => {
  if (e != null) {
    const obj = getJSON(e);
    if (obj != null) {
      return obj[k];
    }
    return e;
  }
  return 'Unknown Error!';
};

const removeParsedKey = (body) => {
  let requestObj = body;
  try {
    // try parsing if its string
    if (typeof body === 'string') {
      requestObj = JSON.parse(body);
    }
    // if array of object
    if (Array.isArray(requestObj)) {
      requestObj = requestObj.map(d => Object.keys(d).reduce((p, c) => {
        if (c.endsWith('_parsed')) {
          return p;
        }
        return {
          ...p,
          [c]: d[c]
        };
      }, {}));
      // if plain object
    } else if (typeof requestObj === 'object') {
      requestObj = Object.keys(requestObj).reduce((p, c) => {
        if (c.endsWith('_parsed')) {
          return p;
        }
        return {
          ...p,
          [c]: requestObj[c]
        };
      }, {});
      requestObj = JSON.stringify(requestObj);
    }
  } catch (e) {
    requestObj = body;
  }
  return requestObj;
};

const http = {
  PUT: (url, loggerInfo, body = {}) => ajax({
    method: 'PUT',
    body,
    headers: {
      appName: process.env.REACT_APP_NAME,
      'Content-Type': 'application/json'
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: true,
    withCredentials: true,
    responseType: 'json'
  }).pipe(map((res) => res)),
  getStreamWithToken: (url, token, loggerInfo, body = {}, responseType = 'blob') => ajax({
    method: 'GET',
    body,
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: false,
    withCredentials: true,
    responseType
  }).pipe(
    map((res) => res),
    catchError((error) => http.errorHandler(error, loggerInfo)),
    finalize(() => { })
  ),
  getWithToken: (url, token, loggerInfo, body = {}, responseType = 'json', surpressErrors = () => { }) => ajax({
    method: 'GET',
    body,
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: false,
    withCredentials: true,
    responseType
  }).pipe(
    map((res) => res),
    catchError((error) => http.errorHandler(error, loggerInfo, 'message', surpressErrors)),
    finalize(() => { })
  ),
  putWithToken: (url, token, body, loggerInfo, responseType = 'json', errorKey = 'message', contentType = 'application/json') => {
    // remove _parsed keys from the request objet to resolve 606 issue -- START
    let requestObj = body || {};
    if (contentType === 'application/json') {
      requestObj = removeParsedKey(body || {});
    }

    // -- END
    return ajax({
      method: 'PUT',
      body: requestObj,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': contentType
      },
      url: process.env.REACT_APP_ORIGIN + url,
      crossDomain: false,
      withCredentials: true,
      responseType
    }).pipe(
      map((res) => res),
      catchError((error) => http.errorHandler(error, loggerInfo, errorKey)),
      finalize(() => { })
    );
  },
  deleteWithToken: (url, token, loggerInfo, body = {}) => ajax({
    method: 'DELETE',
    body,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: false,
    withCredentials: true
  }).pipe(
    map((res) => res),
    catchError((error) => http.errorHandler(error, loggerInfo)),
    finalize(() => { })
  ),
  postWithToken: (url, token, body, loggerInfo, responseType = 'json') => ajax({
    method: 'POST',
    body: body || {},
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: false,
    withCredentials: true,
    responseType
  }).pipe(
    map((res) => res),
    catchError((error) => http.errorHandler(error, loggerInfo)),
    finalize(() => { })
  ),
  get: (url, responseType = 'json') => ajax({
    method: 'GET',
    headers: {
      appName: process.env.REACT_APP_NAME,
      'Content-Type': 'application/json'
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: true,
    withCredentials: true,
    responseType
  }).pipe(map((res) => res)),
  errorHandler: (error, loggerInfo, key, surpressErrors) => {
    if (surpressErrors) {
      return Promise.reject(error);
    }
    const { response, status } = error;

    switch (status) {
      case httpStatusEnum.UNDEFINED:
      case httpStatusEnum.UNAUTHORIZED:
      case httpStatusEnum.NOT_AUTHORIZED:
      case httpStatusEnum.NOT_FOUND_DAO:
      case httpStatusEnum.IMAGE_UPLOAD_EXCEPTION:
      case httpStatusEnum.DOWNLOAD_EXCEPTION:
      case httpStatusEnum.INTERNAL_SERVER_ERROR:
      case httpStatusEnum.ANY_OTHER_EXCEPTION:
      case httpStatusEnum.NOT_VALID_ACTION_EXCEPTION:
      case httpStatusEnum.BAD_REQUEST: {
        const message = getErrorMessage(response, key || 'message');
        OpenErrorNotification({ message, autoHide: true, displayTimeInSec: 15 });
        break;
      }
      default:
    }
    return Promise.reject(error);
  }
};

export default http;
